import { Component, Input } from '@angular/core';
import { Layer } from '../../../../../../shared/models/layer';
import { LayerService } from '../../../../../../shared/services/layer.service';
import { faSquareFull, faCircle, faPlay } from '@fortawesome/free-solid-svg-icons';
import { faCircle as faCircleSmooth } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrl: './legend.component.scss'
})
export class LegendComponent {
  @Input() sidebarIsOpen: boolean = false;
  
  trends = [
    { icon: 'pi pi-arrow-up', label: 'MAP.LEGENDS.TREND.UP' },
    { icon: 'pi pi-equals', label: 'MAP.LEGENDS.TREND.STABLE' },
    { icon: 'pi pi-arrow-down', label: 'MAP.LEGENDS.TREND.DOWN' },
    { icon: 'pi pi-question', label: 'MAP.LEGENDS.TREND.NONE' }
  ];

  levels = [
    { color: '#00408b', label: 'MAP.LEGENDS.LEVEL.VERY_HIGH' },
    { color: '#3071b0', label: 'MAP.LEGENDS.LEVEL.HIGH' },
    { color: '#60a3d6', label: 'MAP.LEGENDS.LEVEL.MODERATELY_HIGH' },
    { color: '#ffde1a', label: 'MAP.LEGENDS.LEVEL.MEDIUM' },
    { color: '#f8930f', label: 'MAP.LEGENDS.LEVEL.MODERATELY_LOW' },
    { color: '#f05200', label: 'MAP.LEGENDS.LEVEL.LOW' },
    { color: '#c50e0e', label: 'MAP.LEGENDS.LEVEL.VERY_LOW' },
    { color: '#d9d9d9', label: 'MAP.LEGENDS.LEVEL.NO_DATA' },
  ];

  layers = [
    { icon: faCircle, class:'icon-legend', label: 'MAP.LEGENDS.LAYER.PIEZO' },
    { icon: faSquareFull, class:'icon-legend', label: 'MAP.LEGENDS.LAYER.SOURCE' },
    { icon: faPlay, class:'rotate-90 icon-legend', label: 'MAP.LEGENDS.LAYER.PLUVIO' },
    { icon: faSquareFull, class:'rotate-45 icon-legend', label: 'MAP.LEGENDS.LAYER.HYDRO' },
    { icon: faCircleSmooth, class:'icon-legend', label: 'MAP.LEGENDS.LAYER.MODEL' },
  ]

  layerState!: Layer;

  constructor(private layerService: LayerService) {}

  ngOnInit(): void {
    this.layerService.currentLayerState$.subscribe((state: Layer) => {
      this.layerState = state;
    });
  }

  // Méthode utilitaire pour vérifier si pluviomètres ou hydrométrie est activé
  isPluviometreOrHydrometrieActive(): boolean {
    return this.layerState.pluviometres || this.layerState.hydrometrie;
  }
}
